import { storage } from '@/utils';
import http from './http';

/**
 * 获取电酒门店详情
 * @returns
 */
export const getDjStoreDetail = (data) => {
  return http({
    method: 'get',
    url: '/store/getDjStoreDetail',
    params: {
      storeCode: storage.get('commonCode'),
    },
    headers: {
      urlPrefix: 'ally-support-svc',
    },
  });
};

/**
 * 获取海外电酒门店详情
 * @returns
 */
export const getOverseaDjStoreDetail = () => {
  return http({
    method: 'get',
    url: '/store/join/getSimpleJoinByCode',
    params: {
      code: storage.get('commonCode'),
    },
    headers: {
      urlPrefix: 'mdm-web',
      user: 'pms-web',
    },
  });
};
/**
 * 获取合同签约人和常用联系人
 * @returns
 */
export const getSignaToryList = (data) => {
  return http({
    method: 'get',
    url: '/ally/queryContractorAndGeneralByStoreCode',
    headers: {
      urlPrefix: 'ally-support-svc',
    },
    params: {
      ...data,
      storeCode: storage.get('commonCode'),
    },
  });
};
/**
 * 获取股东财务信息
 * @returns
 */
export const getShareHolderList = (data) => {
  return http({
    method: 'post',
    url: '/ally/queryShareHolderAndFinancialV2',
    headers: {
      urlPrefix: 'ally-support-svc',
    },
    data: {
      ...data,
      storeCode: storage.get('commonCode'),
    },
  });
};

// 获取预览url
export const preview = (fileUrl, params) => {
  return http({
    method: 'get',
    url: `${fileUrl}`,
    headers: {
      urlPrefix: 'ally-support-svc',
    },
    params,
  });
};

// 函件下载
export const download = (fileUrl, params) => {
  return http({
    method: 'get',
    responseType: 'blob',
    timeout: 30 * 60 * 1000,
    headers: {
      urlPrefix: 'ally-support-svc',
    },
    url: `${fileUrl}`,
    params,
  });
};
/**
 * 获取门店函件列表
 * @returns
 */
export const letterList = (data) => {
  return http({
    method: 'post',
    url: '/storeLetter/getStoreLetterBaseList',
    headers: {
      urlPrefix: 'ally-support-svc',
    },
    data: {
      ...data,
      storeCode: storage.get('commonCode'),
    },
  });
};

// 获取门店详细信息
export const getCurrentStoreDetail = () => {
  return http({
    method: 'GET',
    url: '/hotel/getStoreDetail',
  });
};
